export default {
    methods: {
        clearSelectedLibrariesList() {
            this.selectedLibraries = [];
        },
        libraryName({name}) {
            return name;
        },
        addQuestion(selectOptionValue) {
            let correctObject = null;
            let defaultObject = null;
            if (selectOptionValue === 10) {
                correctObject = {from: null, to: null};
                defaultObject = {from: null, to: null};
            }
            this.questions.push({type: selectOptionValue,
                content: '',
                default: defaultObject,
                correct: correctObject,
                required: '1',
                options: [],
                is_nested: false,
                overriding_question_index: null,
                triggering_answer: null,
            });
            this.selectedQuestionType = 1;
            this.nestedQuestionsErrors.push([]);
        },
        addQuestionOption(index) {
            this.questions[index].options.push({value: '', content: ''});
            this.questionsOptionsContentErrors[index] = [];
        },
        setSelectedQuestionIndex(index) {
            this.selectedQuestionIndex = index;
        },
        removeQuestion(index) {
            this.questions.splice(index, 1);

            this.questions = this.questions.filter(question => {
                return parseInt(question.overriding_question_index) !== index+1;
            });
        },
        removeQuestionOption(index, optionIndex) {
            this.questions[index].options.splice(optionIndex, 1);
        },
        checkValidation: function (e) {
            this.errors = [];
            var isValid = true;
            this.questionsOptionsDefaultErrors = [];
            this.questionsOptionsCorrectErrors = [];

            if (!this.validateSurveyTypeName()) {
                this.errors.push(this.$lang('Należy podać nazwę ankiety.'));
                isValid = false;
            }
            if (!this.validateSurveyTypeDescription()) {
                this.errors.push(this.$lang('Należy podać opis ankiety.'));
                isValid = false;
            }
            if (!this.validateIsCompletedOnce()) {
                this.errors.push(this.$lang('Należy zaznaczyć czy ankieta ma być wypełniana tylko raz.'));
                isValid = false;
            }
            if (!this.validateIsTest()) {
                this.errors.push(this.$lang('Należy zaznaczyć czy ankieta jest testem.'));
                isValid = false;
            }
            if (!this.validateAllLibraries()) {
                this.errors.push(this.$lang('Należy zaznaczyć czy ankieta jest dostępna dla wszystkich bibliotek.'));
                isValid = false;
            }
            if (!this.validateLibrariesList()) {
                this.errors.push(this.$lang('Należy wybrać biblioteki dla których dostępna będzie ankieta lub zaznaczyć opcję dla wszystkich bibliotek.'));
                isValid = false;
            }
            if (!this.validateQuestionsSize()) {
                this.errors.push(this.$lang('Należy dodać co najmniej jedno pytanie.'));
                isValid = false;
            }
            if (!this.validateQuestionsContent()) {
                this.errors.push(this.$lang('Należy napisać  treść do wszystkich pytań.'));
                isValid = false;
            }
            if (!this.validateQuestionsOptionsSize()) {
                this.errors.push(this.$lang('Należy dodać co najmniej jedną opcję wyboru odpowiedzi.'));
                isValid = false;
            }
            if (!this.validateQuestionsOptionsContent()) {
                this.errors.push(this.$lang('Należy dodać treść do wszystkich utworzonych opcji.'));
                isValid = false;
            }
            if (!this.validateQuestionNumberTypeDefault()) {
                this.errors.push(this.$lang('Należy podać liczbę dla domyślnej odpowiedzi w pytaniu typu number.'));
                isValid = false;
            }
            if (!this.validateQuestionsDefaultOption()) {
                this.errors.push(this.$lang('Odpowiedź domyślna pytania z opcjami do wyboru musi być taka sama jak jedna z opcji.'));
                isValid = false;
            }
            if (!this.validateQuestionsCorrectOption()) {
                this.errors.push(this.$lang('Poprawna odpowiedź dla pytania z opcjami do wyboru musi być taka sama jak jedna z opcji.'));
                isValid = false;
            }
            if (!this.validateDateRangeCorrectDefaultAnswers()) {
                this.errors.push(this.$lang('Dla pytań typu "Zakres dat" poprawna odpowiedź musi zawierać wypełnione pola "Od" i "Do".'));
                isValid = false;
            }
            if (!this.validateDateRangeTypeRanges()) {
                this.errors.push(this.$lang('Dla pytań typu "Zakres dat" data w polu "Od" nie może być późniejsza niż w polu "Do".'));
                isValid = false;
            }
            if (!this.validateNestedQuestions()) {
                this.errors.push(this.$lang('Podano błędne dane w pytaniach zależnych.'));
                isValid = false;
            }
            if (isValid) {
                this.submitting = true;
                return true;
            }
            window.scrollTo({top: 0, behavior: 'smooth'});
            e.preventDefault();
        },
        validateSurveyTypeName() {
            return this.surveyTypeName;
        },
        validateSurveyTypeDescription() {
            return this.surveyTypeDescription;
        },
        validateIsCompletedOnce() {
            if (this.isCompletedOnce !== null) {
                return true;
            } else {
                return false;
            }
        },
        validateIsTest() {
            if (this.isTest !== null) {
                return true;
            } else {
                return false;
            }
        },
        validateAllLibraries() {
            if (this.allLibraries !== null) {
                return true;
            } else {
                return false;
            }
        },
        validateLibrariesList() {
            if (parseInt(this.allLibraries) === 0) {
                if (this.selectedLibraries.length === 0) {
                    return false;
                }
            }
            return true;
        },
        validateQuestionsSize() {
            return this.questions.length;
        },
        validateQuestionsContent() {
            if (this.questions.length) {
                var eachQuestionHasContent = true;
                this.questionsContentErrors = [];
                for (var i = 0; i < this.questions.length; i++) {
                    if (!this.questions[i].content) {
                        this.questionsContentErrors[i] = true;
                        eachQuestionHasContent = false;
                    }
                }
                return eachQuestionHasContent;
            }
            return true;
        },
        validateQuestionsOptionsSize() {
            if (this.questions.length) {
                var eachQuestionHasOptions = true;
                this.questionsOptionsErrors = [];
                for (var i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].type > 4 && this.questions[i].type < 8) {
                        if (!this.questions[i].options.length) {
                            this.questionsOptionsErrors[i] = true;
                            eachQuestionHasOptions = false;
                            return false;
                        }
                    }
                }
                return eachQuestionHasOptions;
            }
            return true;
        },
        validateQuestionsOptionsContent() {
            if (this.questions.length) {
                var eachQuestionOptionHasContent = true;
                this.questionsOptionsContentErrors = [];
                for (var i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].type > 4 && this.questions[i].type < 8) {
                        if (this.questions[i].options.length) {
                            this.questionsOptionsContentErrors[i] = [];
                            for (var j = 0; j < this.questions[i].options.length; j++) {
                                if (!this.questions[i].options[j].content) {
                                    this.questionsOptionsContentErrors[i][j] = true;
                                    eachQuestionOptionHasContent = false;
                                }
                            }
                        }
                    }
                }
                return eachQuestionOptionHasContent;
            }
            return true;
        },
        validateQuestionNumberTypeDefault() {
            if (this.questions.length) {
                for (var i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].type === 3) {
                        if (this.questions[i].default) {
                            if (!Number.isFinite(parseInt(this.questions[i].default))) {
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        },
        validateQuestionsDefaultOption() {
            if (this.questions.length) {
                var areQuestionsDefaultAnswersValid = true;
                for (var i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].type > 5 && this.questions[i].type < 8) {
                        if (this.questions[i].default) {
                            var isDefaultOptionValid = false;
                            this.questionsOptionsDefaultErrors[i] = true;
                            for (var j = 0; j < this.questions[i].options.length; j++) {
                                if (this.questions[i].options[j].content === this.questions[i].default) {
                                    isDefaultOptionValid = true;
                                    this.questionsOptionsDefaultErrors[i] = null;
                                }
                            }
                            if (!isDefaultOptionValid) {
                                areQuestionsDefaultAnswersValid = false;
                            }
                        }
                    }
                }
                return areQuestionsDefaultAnswersValid;
            }
            return true;
        },
        validateQuestionsCorrectOption() {
            if (this.questions.length) {
                var areQuestionsCorrectAnswersValid = true;
                for (var i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].type > 5 && this.questions[i].type < 8) {
                        if (this.questions[i].correct) {
                            var isCorrectOptionValid = false;
                            this.questionsOptionsCorrectErrors[i] = true;
                            for (var j = 0; j < this.questions[i].options.length; j++) {
                                if (this.questions[i].options[j].content === this.questions[i].correct) {
                                    isCorrectOptionValid = true;
                                    this.questionsOptionsCorrectErrors[i] = null;
                                }
                            }
                            if (!isCorrectOptionValid) {
                                areQuestionsCorrectAnswersValid = false;
                            }
                        }
                    }
                }
                return areQuestionsCorrectAnswersValid;
            }
            return true;
        },
        validateDateRangeCorrectDefaultAnswers() {
            if (this.questions.length) {
                let areQuestionsCorrectDefaultAnswersValid = true;
                for (let i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].type === 10) {
                        let defaultAnswer = this.questions[i].default;
                        this.questionsOptionsDefaultErrors[i] = [];
                        if ((defaultAnswer.from !== null || defaultAnswer.to !== null)
                            && (defaultAnswer.from === null || defaultAnswer.to === null)) {
                            this.questionsOptionsDefaultErrors[i]['default'] = true;
                            areQuestionsCorrectDefaultAnswersValid = false;
                        }
                        let correctAnswer = this.questions[i].correct;
                        this.questionsOptionsCorrectErrors[i] = [];
                        if ((correctAnswer.from !== null || correctAnswer.to !== null)
                            && (correctAnswer.from === null || correctAnswer.to === null)) {
                            this.questionsOptionsCorrectErrors[i]['correct'] = true;
                            areQuestionsCorrectDefaultAnswersValid = false;
                        }
                    }
                }
                return areQuestionsCorrectDefaultAnswersValid;
            }
            return true;
        },
        validateDateRangeTypeRanges() {
            if (this.questions.length) {
                let areQuestionsRangesValid = true;
                for (let i = 0; i < this.questions.length; i++) {
                    if (this.questions[i].type === 10) {
                        let defaultAnswer = this.questions[i].default;
                        if (defaultAnswer.from && defaultAnswer.to) {
                            if (!this.checkIfDateRangeTypeRangesAreValid(defaultAnswer.from, defaultAnswer.to)) {
                                this.questionsOptionsDefaultErrors[i]['range'] = true;
                                areQuestionsRangesValid = false;
                            }
                        }
                        let correctAnswer = this.questions[i].correct;
                        if (correctAnswer.from && correctAnswer.to) {
                            if (!this.checkIfDateRangeTypeRangesAreValid(correctAnswer.from, correctAnswer.to)) {
                                this.questionsOptionsCorrectErrors[i]['range'] = true;
                                areQuestionsRangesValid = false;
                            }
                        }
                    }
                }
                return areQuestionsRangesValid;
            }
            return true;
        },
        checkIfDateRangeTypeRangesAreValid(from, to) {
            let dateFrom = Date.parse(from);
            let dateTo = Date.parse(to);

            return dateFrom <= dateTo;
        },
        validateNestedQuestions() {
            if (this.questions.length) {
                let areNestedQuestionsValid = true;
                this.nestedQuestionsErrors = [];
                for (var i = 0; i < this.questions.length; i++) {
                    this.nestedQuestionsErrors[i] = [];
                    if (this.questions[i].is_nested) {
                        if (!this.questions[i].overriding_question_index) {
                            this.nestedQuestionsErrors[i]['overriding_question_index'] = true;
                            areNestedQuestionsValid = false;
                        }
                        else if (!this.questions[this.questions[i].overriding_question_index-1]) {
                            areNestedQuestionsValid = false;
                        }
                        else {
                            if (i <= this.questions[i].overriding_question_index-1) {
                                areNestedQuestionsValid = false;
                            }
                            if (this.questions[this.questions[i].overriding_question_index-1].is_nested) {
                                areNestedQuestionsValid = false;
                            }
                            if (this.questions[this.questions[i].overriding_question_index-1].type === 5)  {
                                if (this.questions[i].triggering_answer.length === 0) {
                                    areNestedQuestionsValid = false;
                                    this.nestedQuestionsErrors[i]['correct'] = true;
                                }
                            }
                            else if (this.questions[this.questions[i].overriding_question_index-1].type === 10) {
                                if (this.questions[i].triggering_answer.length < 2) {
                                    areNestedQuestionsValid = false;
                                    this.nestedQuestionsErrors[i]['correct'] = true;
                                } else {
                                    if (!this.checkIfDateRangeTypeRangesAreValid(this.questions[i].triggering_answer[0], this.questions[i].triggering_answer[1])) {
                                        areNestedQuestionsValid = false;
                                        this.nestedQuestionsErrors[i]['range'] = true;
                                    }
                                }
                            }
                            else {
                                if (this.questions[i].triggering_answer === null || this.questions[i].triggering_answer === undefined) {
                                    areNestedQuestionsValid = false;
                                    this.nestedQuestionsErrors[i]['correct'] = true;
                                }
                            }
                        }
                    }
                }
                return areNestedQuestionsValid;
            }
            return true;
        },
        setTriggeringAnswerForDateRange(nestedQuestionId, overridingQuestionId) {
            this.questions[nestedQuestionId].triggering_answer = null;
            if (overridingQuestionId !== null) {
                if (this.questions[overridingQuestionId] && this.questions[overridingQuestionId].type === 5
                    || this.questions[overridingQuestionId] && this.questions[overridingQuestionId].type === 10) {
                    this.questions[nestedQuestionId].triggering_answer = [];
                }
            }
        },
    },
    created() {
        if (this.questions.length>0) {
            for (var index=0; index<this.questions.length; index++) {
                this.questionsOptionsContentErrors[index] = [];
                this.nestedQuestionsErrors[index] = [];
            }
        }
    }
}
